import { render, staticRenderFns } from "./year-list.vue?vue&type=template&id=61b68629"
import script from "./year-list.vue?vue&type=script&lang=js"
export * from "./year-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports